import { SEARCH_PARAMS_KEYS } from '$constants';

export const VERIFICATION_ID_URL_KEY = 'verificationId';

export const API_URLS = {
  parseFile: '/api/verification-creation/file/data',
  getDocumentList:
    '/api/verification-modification/component-and-document-type?verificationRequestId=#{verificationRequestId}&claimId=#{claimId}',
  getCSVFileofVerifications:
    '/api/partner-verification-list/verification-csv-file?filters=#{filters}&levelType=#{levelType}',
  getIaNames: `/api/track-cases/get-ia-names?iaName=#{iaName}`,
  GET_COUNTRY: `/api/verification-initiation/partner/countries`,
  COUNTRY_ICONS: `${process.env.NEXT_PUBLIC_STATIC_URL}/images/country`,
  getDashboardNavItems: '/api/config/partnerDashboardNavConfig',
  getLetter:
    '/api/letter-of-auth?verificationRequestId=#{verificationRequestId}',
  generateLoaOtp: '/api/letter-of-auth/generate-otp',
  verifyLetterOfAuth: '/api/letter-of-auth/verify-otp',
  getUserById: '/api/user/#{userId}',
  sendMobileOtp: `/api/onboarding-mobile/mobile/otp`,
  verifyMobileOtp: `/api/onboarding-mobile/mobile/otp/verify`,
  resendMobileOtp: '/api/onboarding-mobile/mobile/resend/otp',
  generateCaptcha: '/api/onboarding/captcha',
  reInviteApplicant: '/api/invite-applicant/re-invite',
  getVerificationDetailsByCaseId:
    '/api/verification-details/verification-details-by-case-id?caseId=#{caseId}&fetchApplicant=#{fetchApplicant}',
  getWorkflowStageHistory:
    '/api/verification-details/workflow-stage-history?entityId=#{entityId}&workflowStage=#{workflowStage}&startTimeStamp=#{startTimeStamp}&endTimeStamp=#{endTimeStamp}',
  getPaymentPackageDetailsFromVR:
    '/api/verification-details/get-payment-package-details/#{verificationRequestId}',
  getRefundPayoutsByVRId:
    '/api/payments/get-refund-by-vr/#{verificationRequestId}',
  deleteVerificationRequest:
    '/api/verification-modification/verification?verificationRequestId=#{verificationRequestId}',
  additionalAuthConfig:
    '/api/verification-creation/additonal-auth-config?state=#{state}&type=#{type}',
  getTeamMembers:
    '/api/settings-partner/team-members?currentPage=#{currentPage}',
  updateTeamMember: '/api/settings-partner/update-member',
  getCompanyData:
    '/api/partner-onboarding/company-data?companyName=#{companyName}',
  createCompanyDetails: '/api/partner-onboarding/company-details',
  getPartnerType: '/api/partner-onboarding/partner-type',
  getCountriesList: '/api/config/nationalities',
  getActiveFeatureConfig: `/api/config/active-features`,
  getUser: `/api/user`,
  getPartnerUserById: `/api/user/partner-user`,
  getPartnerUser: `/api/partner/partner-user/#{partnerUserId}`,
  updateUserById: '/api/user/#{userId}',
  logOutUrl: '/api/partner/log-out',
  getAboutYourself: '/api/onboarding-applicant/config',
  getNationalityDetails: '/api/config/nationalities',
  getClientContract:
    '/api/verification-initiation/new-client-contract?clientId=#{clientId}&purposeId=#{purposeId}&purposeCategoryId=#{purposeCategoryId}&countryCode=#{countryCode}&applicantId=#{applicantId}',
  getClientContractByVRId:
    '/api/verification-initiation/new-client-contract?verificationRequestId=#{verificationRequestId}&applicantId=#{applicantId}',
  createVerification: '/api/verification-creation/create',
  parsePassportAndResolveApplicant:
    '/api/verification-creation/file/parse-passport-and-resolve-applicant',
  executeRenewalCasePrecondition:
    '/api/verification-creation/execute-renewal-case-precondition?clientId=#{clientId}&applicantUserId=#{applicantUserId}&clientContractId=#{clientContractId}',
  getVerificationStatus:
    '/api/verification-details/status/#{verificationRequestId}',
  getHome: '/api/partner-home',
  getVeriflowCases: '/api/partner-verification-list/veriflow-cases',
  getVerificationDetailsById:
    '/api/verification-details/verification-request/#{verificationId}?fetchApplicant=#{fetchApplicant}',
  cancelVerification: '/api/verification-creation/cancel',
  getVerification: '/api/verification-dashboard',
  verificationInsuffiency:
    '/api/verification-modification/insufficiency?verificationId=#{verificationId}&includeSubmitted=#{includeSubmitted}',
  getLegacyCaseAppealUrl:
    '/api/verification-modification/legacy-case-appeal-url?caseId=#{caseId}',
  notifications: '/api/notifications',
  updateReadStatus: '/api/notifications/updateReadStatus',
  notificationsStatus: '/api/notifications/getNotificationsStatus',
  updateInsufficiency: '/api/verification-modification/insufficiency',
  getS3DocumentUrls:
    '/api/verification-creation/pre-signed-urls?fileIds=#{fileIds}',
  startVerification: '/api/verification-initiation/verification/start',
  updateBulkUploadParentDocuments:
    '/api/verification-initiation/verification/case-creation',
  logIn: '/api/partner/login',
  forgotPassword: '/api/partner/forgotPassword',
  resetPassword: '/api/partner/resetPassword',
  setPassword: '/api/partner/setPassword',
  emailUrl: '/api/partner/add-email',
  resendOtp: '/api/onboarding/resend/otp',
  emailVerify: '/api/partner/otpVerify',
  updateUser: '/api/user/#{userId}',
  invitePartnerMembers: '/api/settings-partner/invite-team-members',
  getPartnerRoles: '/api/settings-partner/roles',
  createApplicant: '/api/user',
  createClientContractBasedApplicant: '/api/user/contract-based-applicant',
  postSignedLetter: '/api/verification-sign-letter',
  getIaListDetailsByName:
    '/api/ia-selection/list?name=#{name}&iaStatus=#{iaStatus}&iaOfficeId=#{iaOfficeId}',
  startPaymentTransaction:
    '/api/payments/start-payment-transaction?subDomain=#{subDomain}',
  getPaymentTransactionDetails:
    '/api/payments/payment-transaction-details?paymentTransactionId=#{paymentTransactionId}&verificationRequestId=#{verificationRequestId}',
  getPartnerVerificationList:
    '/api/partner-verification-list?isApprovalPending=#{isApprovalPending}&isPaymentPending=#{isPaymentPending}',
  getPartnerVerificationListByFilter:
    '/api/partner-verification-list/filters?isApprovalPending=#{isApprovalPending}&isPaymentPending=#{isPaymentPending}',
  getPlaceAutocomplete: '/api/location/place-autocomplete?query=#{query}',
  getPlaceDetails: '/api/location/place',
  getMrl:
    '/api/verification-mrl?officeId=#{officeId}&componentId=#{componentId}&applicantUserId=#{applicantUserId}',
  deleteNameChangeComponent:
    '/api/verification-initiation/delete-discrepant-component',
  updateSignedLetter: '/api/verification-sign-letter',
  postPricingDetails: '/api/price-details/pricing-details',
  getPartnerAccountDetails: '/api/settings-partner/partner',
  getFreeExpressQuota: '/api/settings-partner/free-express-quota',
  updatePartnerAccountDetails: '/api/settings-admin-partner/partner',
  errorLog: '/api/log',
  getSubmitApplicationDetailsByVr:
    '/api/verification-details/submit-application-details?verificationRequestId=#{verificationRequestId}',
  getCaseHistoryOfVR:
    '/api/verification-details/case-history?verificationRequestId=#{verificationRequestId}',
  sendVRForApproval:
    '/api/verification-details/send-vr-for-approval/#{verificationRequestId}',
  updateLatestPartnerAdminResponse:
    '/api/verification-details/update-latest-partner-admin-response/#{verificationRequestId}',
  getSupportConfig: '/api/cosmos/support-config',
  getVerificationRequestListForAdditionalComponent:
    '/api/verification-details/verification-list?applicantId=#{applicantId}&clientId=#{clientId}&source=#{source}',
  getApprovalSentDataSSR:
    '/api/verification-details/approval-sent-data/#{verificationRequestId}',
  transferOwnership: '/api/fetch-report/transfer-ownership',
  // Tab version crls APIs
  getClientRequirementListTabs: `/api/client-requirement/client-requirement-list-tabs?verificationRequestId=#{verificationRequestId}&crlId=#{crlId}&tabId=#{tabId}`,
  getClientRequirementListTabData: `/api/client-requirement/client-requirement-list-tab-data?verificationRequestId=#{verificationRequestId}&crlId=#{crlId}&tabId=#{tabId}`,
  postClientRequirementListsResponseTab: `/api/client-requirement/client-requirement-response-tab`,
  postClientRequirementDocumentsTab: `/api/client-requirement/client-requirement-document-tab`,
  validateField: `/api/client-requirement/validate-field?verificationRequestId=#{verificationRequestId}`,
  logInUrl: '/api/onboarding/login/otp',
  updateVerificationRequest:
    '/api/verification-creation/verification-request?verificationRequestId=#{verificationRequestId}',
  getCtaTokenDetails: '/api/cta-token/details?token=#{token}',
  getVerificationResumeUrl:
    '/api/verification-creation/verification-resume-url?verificationRequestId=#{verificationRequestId}',
  getOfficeDetails: `/api/verification-creation/iaOfficeDetails/?officeId=#{officeId}`,
  GET_AUTHORITY: `/api/verification-initiation/clients/?country=#{country}`,
  getVDTabContent:
    '/api/verification-details/partner/tabs/#{tabKey}?verificationRequestId=#{verificationRequestId}',
  getVDTabContentByCaseId:
    '/api/verification-details/partner/tabs/#{tabKey}?caseId=#{caseId}',
  getVDInsufficiency:
    '/api/verification-details/partner/insufficiency?verificationRequestId=#{verificationRequestId}',
  getVDInsufficiencyByCaseId:
    '/api/verification-details/partner/insufficiency?caseId=#{caseId}',
  getVDTabConfig:
    '/api/verification-details/partner/tab-config?verificationRequestId=#{verificationRequestId}',
  getVDTabConfigByCaseId:
    '/api/verification-details/partner/tab-config?caseId=#{caseId}',
  getVDCaseHistoryStageDetail:
    '/api/verification-details/partner/case-history-stage-detail?entityId=#{entityId}&workflowStage=#{workflowStage}&startTimeStamp=#{startTimeStamp}',
  applicationBatch: '/api/case-creation/application-batch',
  getApplicationBatch:
    '/api/case-creation/application-batch/#{applicationBatchId}?initiatorId=#{initiatorId}',
  updateApplicantDetails:
    '/api/case-creation/application-batch/applicant-details'
};

export const VERIFICATION_API_URLS = {
  getVerificationOverview: `/api/verification-creation/overview`,
  verificationOverview: `/api/verification-creation/verification-overview?verificationRequestId=#{verificationRequestId}`,
  getVerificationOverviewSummary: `/api/verification-details/overview-summary?verificationRequestId=#{verificationRequestId}`,
  getApplicantDOB: '/api/user/applicant/dob?applicantUserId=#{applicantUserId}',
  claimItems: '/api/verification-creation/claim-items',
  claimItemsForContract:
    '/api/verification-creation/claim-items?contractId=#{contractId}',
  completeInitialClaim: '/api/verification-creation/complete-initial-claim',
  getVerifiableComponents: `/api/verification-creation/verifiable-components?verificationRequestId=#{verificationRequestId}`,
  addSingleVerifiableComponent: `/api/verification-creation/verifiable-component`,
  deleteSingleVerifiableComponent: `/api/verification-creation/verifiable-component`,
  getIssuersData: `/api/verification-creation/issuers-data?verificationRequestId=#{verificationRequestId}`,
  updateIssuersForClaim: `/api/verification-creation/update-issuers-for-claim`,
  extractFile:
    '/api/verification-creation/file/extract-attributes/?fileId=#{fileId}',
  moveToVerification: '/api/verification-creation/move-to-verification',
  getAllActiveClientAndPurposeDetails:
    '/api/verification-initiation/get-all-active-clients-and-purposes',
  inviteApplicant: '/api/invite-applicant',
  inviteApplicantForLoa: '/api/invite-applicant/loa',
  cancelInvite: '/api/invite-applicant/cancel-invite',
  getInviteApplicantPriceDetails:
    '/api/invite-applicant/price-details?clientIds=#{clientIds}&purposeIds=#{purposeIds}&purposeCategoryIds=#{purposeCategoryIds}',
  createApplicantAndVerification:
    '/api/invite-applicant/create-applicant-and-verification',
  addAddonAndInvite: '/api/invite-applicant/invite-applicant',
  getInviteApplicantVerificationsDetails:
    '/api/invite-applicant/verifications-details?verificationRequestIds=#{verificationRequestIds}',
  getAppealDetails:
    '/api/verification-modification/appeal-details?verificationRequestId=#{verificationRequestId}',
  replaceClaimItemV2: '/api/verification-modification/replace-claim-item-v2',
  replaceClaimItem: '/api/verification-modification/replace-claim-item',
  getRequestCorrectionDetails:
    '/api/verification-modification/request-correction-details?verificationRequestId=#{verificationRequestId}',
  raiseAppealError:
    '/api/verification-modification/raise-appeal-error?subDomain=#{subDomain}',
  createNameChangeComponent:
    '/api/verification-initiation/create-discrepant-component?verificationRequestId=#{verificationRequestId}',
  createReportTransferComponent:
    '/api/verification-creation/report-transfer-component',
  getFetchReportReissuePricingDetails:
    '/api/price-details/fetch-reissue-report-pricing?verificationRequestId=#{verificationRequestId}',
  createDiscrepantId:
    '/api/facet-intelligence/name-change-data?verificationRequestId=#{verificationRequestId}',
  deleteNameChangeComponent:
    '/api/verification-initiation/delete-discrepant-component',
  getPricingDetails:
    '/api/price-details/pricing-details?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}&screenType=#{screenType}',
  getAddonsPricingDetails:
    '/api/price-details/add-ons-pricing-details?verificationRequestId=#{verificationRequestId}',
  getAppealPricingDetails:
    '/api/price-details/appeal-pricing?verificationRequestId=#{verificationRequestId}',
  postPricingDetails: '/api/price-details/pricing-details',
  getSpeciality: `/api/verification-initiation/all-purpose-categories?clientId=#{clientId}&countryCode=#{countryCode}`,
  getVerificationRequestPricingDetails: `/api/price-details/verification-request-pricing?verificationRequestId=#{verificationRequestId}`,
  getBulkVerificationRequestPricingDetails: `/api/price-details/bulk-verification-request-pricing`,
  verificationOverviewPdf: '/api/verification-details/overviewPdf',
  deleteClaims: '/api/verification-modification/delete-claims',
  postMRLInsufficiencyAction:
    '/api/verification-modification/mrlInsufficiency?verificationRequestId=#{verificationRequestId}',
  updateSupportingDocumentDetails:
    '/api/verification-modification/supporting-document-details',
  getReportTransfer: `${process.env.NEXT_PUBLIC_BFF_URL}/verification-initiation/report-transfer?verificationRequestId=#{verificationRequestId}&${SEARCH_PARAMS_KEYS.applicantUserId}=#{${SEARCH_PARAMS_KEYS.applicantUserId}}`,
  postReissueReportPaymentContract:
    '/api/price-details/post-reissue-report-payment-contract?verificationRequestId=#{verificationRequestId}',
  getInsufficiencyPricingDetails:
    '/api/price-details/insufficiency-pricing-details?verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}',
  getFetchReportPricingDetails:
    '/api/price-details/fetch-report-pricing?verificationRequestId=#{verificationRequestId}',
  postReportTransfer: '/api/verification-initiation/report-transfer',
  postReportSharing: '/api/verification-initiation/report-sharing',
  getReportDocumentDetails: `/api/fetch-report/report-document-details?documentId=#{documentId}`,
  getExistingReports: `/api/fetch-report/existing-reports?passportNo=#{passportNo}&dob=#{dob}&email=#{email}&phoneNo=#{phoneNo}&${SEARCH_PARAMS_KEYS.applicantUserId}=#{${SEARCH_PARAMS_KEYS.applicantUserId}}&clientContractId=#{clientContractId}`,
  getRTFlowMetadata: `/api/verification-creation/rt-flow-metadata`,
  detectAutoInsufficiency:
    '/api/verification-details/detect-auto-insufficiency?verificationRequestId=#{verificationRequestId}',
  detectDuplicateComponents:
    '/api/verification-creation/detect-duplicate-components',
  documentTypeChangeOptions:
    '/api/document-type-change/options?claimItemId=#{claimItemId}',
  documentTypeChangeInitiate: '/api/document-type-change/initiate',
  documentTypeChangeStatus: '/api/document-type-change/#{claimItemId}/status',
  documentTypeChangeApply: '/api/document-type-change/apply',
  documentTypeChangeReject: '/api/document-type-change/reject'
};

export const VERIFICATION_UPLOAD_API_URLS = {
  getComponentsDetails:
    '/api/verification-creation/components?verificationRequestId=#{verificationRequestId}&filteredComponentTypeIds=#{filteredComponentTypeIds}&applicantUserId=#{applicantUserId}',
  getAdditionalSteps:
    '/api/verification-creation/additional-components?verificationRequestId=#{verificationRequestId}&isParent=#{isParent}',
  getComponent:
    '/api/verification-creation/component?componentId=#{componentId}&verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}',
  componentUrl: '/api/verification-creation/component',
  documentUrl: '/api/verification-creation/document',
  addAdditionalComponent:
    '/api/verification-creation/additional-components?source=#{source}',
  getDepartmentCourseByComponentId:
    '/api/verification-creation/get-department-course?componentId=#{componentId}&iaOfficeId=#{iaOfficeId}',
  getNameChangeGaps:
    '/api/facet-intelligence/name-change-gaps?verificationRequestId=#{verificationRequestId}',
  getVerificationDiscrepancyDetails:
    '/api/verification-creation/verification-discrepancy-details?verificationRequestId=#{verificationRequestId}'
};

export const VERIFICATION_UPLOAD_V2_API_URLS = {
  getComponentsDetails:
    '/api/verification-creation-v2/components?verificationRequestId=#{verificationRequestId}&filteredComponentTypeIds=#{filteredComponentTypeIds}',
  getComponent:
    '/api/verification-creation-v2/component?componentId=#{componentId}&verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}',
  editableComponentUrl: '/api/verification-creation-v2/editable-component',
  documentUrl: '/api/verification-creation/document'
};

export const DOCUMENT_UPLOAD_URL = `${process.env.NEXT_PUBLIC_DOCUMENT_SERVICE_URL}/upload`;
